import { AxiosRequestConfig } from 'axios';

import Client from './client';
import { Wallet } from './types';

type Response = Wallet;

export default (config?: AxiosRequestConfig) => {
  return Client.get<Response>('/payment/v1/wallet', config);
};
